import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  row: {
    borderTopWidth: 1,
    borderColor: cloudLight,
  },
  sponsoredDate: {
    marginTop: 10,
    width: '70%',
  },
  bottomSpace: {
    height: 50,
  },
});
